import { useEffect, useState } from 'react';
import { Shell } from './components/Brand.js';
import { Maintenance } from './components/Maintenance.js';
import { Invitation } from './guest/Invitation.js';
import { Contact } from './pages/Contact.js';
import { Landing } from './pages/Landing.js';
import { CreateEvent, Enter } from './host/CreateEvent.js';
import { Dashboard } from './host/Dashboard.js';
import { Invites } from './host/Invites.js';
import { Import } from './host/Import.js';
import { Reception } from './host/Reception.js';
import { match, usePath } from './router.js';

export function App() {
  const path = usePath();
  const [down, setDown] = useState<string | null>(null);

  useEffect(() => {
    const onDown = (event: Event) => {
      const detail = (event as CustomEvent<{ reason?: string | null }>).detail;
      setDown(detail?.reason ?? '');
    };
    window.addEventListener('presente:maintenance', onDown);
    return () => window.removeEventListener('presente:maintenance', onDown);
  }, []);

  if (down !== null) return <Maintenance reason={down || null} />;

  // Guest first: it is the path 21 families take and the one that has to be
  // fast.
  const invite = match('/c/:token', path);
  if (invite) {
    return (
      <Shell quiet>
        <Invitation token={invite.token!} />
      </Shell>
    );
  }

  if (path === '/contato') return <Contact />;

  const enter = match('/entrar/:token', path);
  if (enter) return <Enter token={enter.token!} />;

  const dashboard = match('/painel/:eventId', path);
  if (dashboard) {
    return (
      <Shell>
        <Dashboard eventId={dashboard.eventId!} />
      </Shell>
    );
  }

  const invites = match('/convites/:eventId', path);
  if (invites) {
    return (
      <Shell>
        <Invites eventId={invites.eventId!} />
      </Shell>
    );
  }

  const reception = match('/recepcao/:eventId', path);
  if (reception) {
    return (
      <Shell>
        <Reception eventId={reception.eventId!} />
      </Shell>
    );
  }

  const importing = match('/importar/:eventId', path);
  if (importing) {
    return (
      <Shell>
        <Import eventId={importing.eventId!} />
      </Shell>
    );
  }

  if (path === '/criar') {
    return (
      <Shell>
        <CreateEvent />
      </Shell>
    );
  }

  if (path === '/') {
    return (
      <Shell>
        <Landing />
      </Shell>
    );
  }

  return (
    <Shell>
    <div className="page">
      <h1>Não encontramos esta página</h1>
      <p className="muted">Confira o link que você recebeu.</p>
      <a className="button block" href="/">
        Criar uma festa
      </a>
    </div>
    </Shell>
  );
}
